import { extractFilesFromEntry } from 'features/entry-form-v2/create-entry/CreateEntryPageV1_5';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { Entry } from 'features/entry-form-v2/types';
import { useState } from 'react';
import { submitFilesForSurvey } from './submitFilesForSurvey';

export type SurveyResponseMutationResult = {
	httpStatusCode: number;
	entryId: string;
	errors?: {
		code: string;
	}[];
};

export const useCreateSurveyResponseMutation = () => {
	const [data, setData] = useState<SurveyResponseMutationResult>();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<Error>();

	async function mutateAsync({
		surveyId,
		entry,
		pinCode
	}: {
		surveyId: string;
		entry: Entry;
		pinCode: string;
	}) {
		setLoading(true);

		try {
			const { entryWithoutFiles, files } = extractFilesFromEntry({
				entry
			});

			const result: SurveyResponseMutationResult = await makeRequest({
				method: 'createSurveyResponse',
				service: 'cde',
				validateCredentials: false,
				data: {
					surveyId,
					entry: entryWithoutFiles,
					pinCode
				}
			});

			if (files.length > 0) {
				await submitFilesForSurvey({
					surveyId,
					pinCode,
					entryId: result.entryId,
					files
				});
			}

			setData(result);
			return result;
		} catch (e) {
			setError(e as Error);

			// In order for the code to stop running if we await this and it fails, we need to rethrow the error
			// not sure how to solve this in a best possible way
			throw e;
		} finally {
			setLoading(false);
		}
	}

	return {
		data,
		loading,
		error,
		mutateAsync,
		reset: () => {
			setData(undefined);
			setLoading(false);
			setError(undefined);
		}
	};
};
